import BackendService from './BackendService';

async function getSalesByDate(data = {}) {
  return BackendService.postData('/reports/by_date/', data);
}

async function getSalesSummary(params = {}) {
  return BackendService.getData('/reports/summary/', {}, params);
}
async function getSaleOrderTypeReport(data = {}) {
  return BackendService.postData('/reports/order-type-summary/', data);
}
async function getMultiShopSummary(params = {}) {
  return BackendService.getData('/multi-shop/reports/summary/', {}, params);
}

const SalesReportsService = {
  getSalesByDate,
  getSalesSummary,
  getSaleOrderTypeReport,
  getMultiShopSummary,
};

export default SalesReportsService;
